/**
 * Get Recommended Products Use Case
 *
 * Retrieves product recommendations for cross-sell on the PDP.
 */

import { IProductService } from '@/domain/services/product.service.interface';
import { ProductEntity } from '@/domain/entities/product.entity';

export interface GetRecommendedProductsInput {
  productId: string;
  limit?: number;
}

export interface GetRecommendedProductsOutput {
  products: ProductEntity[];
}

export class GetRecommendedProductsUseCase {
  constructor(private readonly productService: IProductService) {}

  async execute(input: GetRecommendedProductsInput): Promise<GetRecommendedProductsOutput> {
    if (!input.productId || input.productId.trim() === '') {
      return { products: [] };
    }

    const products = await this.productService.getRecommendedProducts(
      input.productId,
      input.limit,
    );

    return { products };
  }
}
